<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">
            <v-btn
                small
                icon
                @click="close"
                color="primary"
                class="ml-n3 mr-2 my-2 py-0"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            Shipments
            <v-chip color="primary" small label class="ml-2 white--text">
                {{ tableData.length }}
            </v-chip>
            <v-spacer />
            <v-btn
                rounded
                color="success"
                @click="$emit('exportExcel')"
                :disabled="tableData.length === 0 || loading"
                small
                class="white--text mr-2"
            >
                <v-icon left small>mdi-microsoft-excel</v-icon>
                EXPORT EXCEL
            </v-btn>
        </v-card-title>
        <v-divider class="ml-4 mr-5 mb-2" />
        <v-card-text class="pb-0">
            <v-data-table
                disable-pagination
                hide-default-footer
                :headers="headers"
                :items="tableData"
                class="elevation-0"
                :mobile-breakpoint="0"
                :loading="loading"
                fixed-header
                height="550px"
            >
                <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                </template>

                <template v-slot:[`item.Important`]="{ item }">
                    <v-icon v-if="item.Important === 'Yes'" color="red" small>
                        mdi-flag
                    </v-icon>
                    <span v-else>-</span>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ShipmentTable',
    props: {
        filteredEvents: {
            type: Array,
            required: true,
        },
        dateRange: {
            type: Object,
            required: true,
        },
        companyCountry: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        tableHeight: 0,
        headers: [
            {
                text: '#',
                value: 'index',
                sortable: false,
                width: 60,
                align: 'center',
            },
            { text: 'Date', width: 110, value: 'Date', sortable: true },
            { text: 'Container', value: 'Container', sortable: false },
            { text: 'Packing List', value: 'Packing List', sortable: false },
            { text: 'Project', value: 'Project', sortable: false },
            { text: 'Status', value: 'Status', sortable: false },
            { text: 'Shipping Type', value: 'Shipping Type', sortable: false },
            { text: 'Destination', value: 'Destination', sortable: false },
            {
                text: 'Destination Country',
                value: 'Destination Country',
                sortable: false,
            },
            { text: 'Work Orders', value: 'Work Orders', sortable: false },
            {
                text: 'Important',
                width: 50,
                value: 'Important',
                sortable: false,
            },
        ],
    }),
    computed: {
        tableData() {
            const visibleEvents = this.filteredEvents.filter(event => {
                if (!event.elements) return false
                const eventDay = moment(event.start).format('YYYY-MM-DD')
                const startDay = moment(this.dateRange.start.date).format(
                    'YYYY-MM-DD'
                )
                const endDay = moment(this.dateRange.end.date).format(
                    'YYYY-MM-DD'
                )
                return eventDay >= startDay && eventDay <= endDay
            })

            visibleEvents.sort((a, b) => new Date(a.start) - new Date(b.start))

            const rows = []
            visibleEvents.forEach(event => {
                event.elements.forEach(el => {
                    rows.push({
                        Date: moment(event.start).format('YYYY-MM-DD'),
                        Container: event.container || '-',
                        'Packing List': el.packingList?.code || '-',
                        Project: el.project
                            ? `${el.project.reference} - ${el.project.name}`
                            : '-',
                        Status: el.packingList?.status || '-',
                        'Shipping Type': el.packingList?.airShipment
                            ? 'Air Shipment'
                            : 'Standard',
                        Destination: el.project?.country
                            ? el.project.country.toLowerCase() ===
                              this.companyCountry
                                ? 'National'
                                : 'Export'
                            : '-',
                        'Destination Country': el.project?.country || '-',
                        'Work Orders': el.packingList?.selectedWorkOrders
                            ? el.packingList.selectedWorkOrders
                                  .map(wo => wo.code)
                                  .join(', ')
                            : '-',
                        Important: el.packingList?.important ? 'Yes' : 'No',
                    })
                })
            })

            return rows
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.onResize()
        })
    },
    methods: {
        close() {
            this.$emit('close')
        },
        onResize() {
            this.$nextTick(() => {
                const headerHeight = this.$refs.tableHeader
                    ? this.$refs.tableHeader.offsetHeight
                    : 100
                this.tableHeight = window.innerHeight - headerHeight
            })
        },
    },
}
</script>

<style scoped>
.v-data-table {
    border: 1px solid #eeeeee;
}
.v-data-table >>> thead {
    background-color: #eeeeee;
}
</style>
